module.exports = __webpack_public_path__ + "img/ipad_jp.fae9a84.jpg";